import computeClassName from '../../../../../utils/computeClassName';
import NavigationLinksGroup1 from "../NavigationLinksGroup1";
import NavigationLinksGroup2 from "../NavigationLinksGroup2";
import UtilityLinks from "../../UtilityLinks";

const constants = Object.freeze({
  CLASSNAME_BASE: 'bg-cc-primary text-cc-primary-contrast w-full p-6 pb-0 shadow-cc-menu'
});

export default function MobileMenu(
  {
    className = '',
  }
) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    <div className={computedClassName}>
      <NavigationLinksGroup1/>
      <NavigationLinksGroup2/>
      <UtilityLinks/>
    </div>
  );
}
